import { Group, Vector3 } from 'three/webgpu'

export default class DeviceControl extends Group {
	static defaults = { source: null, camera: null }
	static draggable = false

	constructor(options = {}) {
		super()

		this.options = { ...DeviceControl.defaults, ...this.constructor.defaults, ...options }

		const { source } = this.options

		this.source = source
		this.host = source.parent
		this.name = source.name
		this.rest = source.position.clone()
		this.base = source.rotation.clone()
		this.sizing = source.scale.clone()
		this.point = new Vector3()

		this.position.copy(this.rest)
		this.quaternion.copy(source.quaternion)
		this.scale.copy(this.sizing)

		source.position.set(0, 0, 0)
		source.rotation.set(0, 0, 0)
		source.scale.set(1, 1, 1)

		this.add(source)
	}

	project(target, axis) {
		this.point.copy(this.rest)

		if (axis) this.point[axis] += 1

		this.parent.localToWorld(this.point)
		this.point.project(this.options.camera)

		return target.set(((this.point.x + 1) / 2) * window.innerWidth, ((1 - this.point.y) / 2) * window.innerHeight)
	}

	release() {}

	dispose() {
		this.source.position.copy(this.rest)
		this.source.rotation.copy(this.base)
		this.source.scale.copy(this.sizing)
		this.host?.add(this.source)
		this.removeFromParent()
	}
}
